module.exports = __webpack_public_path__ + "static/img/right.664b24f6.png";